import React, { useMemo } from 'react';
import ContentBox from '@root/components/v2/content/ContentBox';
// import Text from '@root/components/v2/ui-elements/Text';
import { SEVERITY_BACKGROUND_COLORS, UI_COLORS } from '@root/utilities/pastelColors';
// import { kFormatter } from '@root/utilities/common';

const SEVERITIES = [
  { key: 'critical', label: 'Critical' },
  { key: 'high', label: 'High' },
  { key: 'medium', label: 'Medium' },
  { key: 'low', label: 'Low' },
];

// Severity breakdown built from the AIMisconfiguration card pattern (bar + count + label per
// severity). See src/pages/ai-security/components/AIMisconfiguration.jsx.
const SeverityBreakdownCard = ({ severity, total }) => {
  const data = useMemo(
    () => SEVERITIES.map(({ key, label }) => ({ severity: key, label, count: severity?.[key] ?? 0 })),
    [severity],
  );

  const totalCount = total ?? data.reduce((sum, item) => sum + item.count, 0);

  return (
    <ContentBox
      title="Severity Breakdown"
      paddingMode="content"
      height={'100%'}
      style={{ backgroundColor: UI_COLORS.background.primary }}
      // headerEndElement={
      //   <Text
      //     className="rounded-full px-2 py-0.5 text-[12px]"
      //     font="semi-bold"
      //     element="span"
      //     style={{ backgroundColor: UI_COLORS.background.secondary, color: UI_COLORS.text.secondary }}>
      //     {Number(totalCount).toLocaleString()} findings
      //   </Text>
      // }
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '15px' }}>
        <div style={{ fontSize: '24px', fontWeight: 600, color: UI_COLORS.text.primary, marginBottom: '20px' }}>
          {Number(totalCount).toLocaleString()}
        </div>

        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', gap: '8px', marginTop: '8px' }}>
          {data.map((item, index) => {
            const palette = SEVERITY_BACKGROUND_COLORS[item.severity.toUpperCase()];
            return (
              <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                <div
                  style={{
                    height: '4px',
                    width: '100%',
                    backgroundColor: palette?.background,
                    borderRadius: '2px',
                    marginBottom: '8px',
                  }}
                />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    color: palette?.text,
                    fontWeight: 600,
                    fontSize: '22px',
                    marginBottom: '4px',
                  }}>
                  {/* {kFormatter(item.count)}*/}
                  {item?.count || 0}
                </div>
                <div
                  style={{ fontSize: '13px', color: UI_COLORS.text.secondary, fontWeight: 500, textAlign: 'center' }}>
                  {item.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ContentBox>
  );
};

export default SeverityBreakdownCard;
